import React, { ForwardedRef, ReactNode, forwardRef } from 'react';
import { StandardParagraphSize, StyledParagraph, StyledParagraphProps } from './paragraph.styles';

interface ParagraphProps extends StyledParagraphProps {
  text?: string;
  children?: ReactNode;
  className?: string;
  hasHtmlInText?: boolean;
}

const Paragraph = (props: ParagraphProps, ref: ForwardedRef<HTMLParagraphElement>): JSX.Element => {
  const { standardSize } = props;

  const size = props.size || StandardParagraphSize[standardSize]?.desktop;
  const sizeLg = props.sizeLg ?? StandardParagraphSize[standardSize]?.lg;
  const sizeSm = props.sizeSm ?? StandardParagraphSize[standardSize]?.sm;

  const sizeProps = {
    size,
    sizeLg,
    sizeSm,
  };

  if (props.hasHtmlInText) {
    return (
      <StyledParagraph
        dangerouslySetInnerHTML={{ __html: props.text }}
        ref={ref}
        {...sizeProps}
        {...props}
      />
    );
  }

  return (
    <StyledParagraph
      ref={ref}
      {...sizeProps}
      {...props}
    >
      {props.text || props.children}
    </StyledParagraph>
  );
};

export default forwardRef<HTMLParagraphElement, ParagraphProps>(Paragraph);
